(function () {
  function findKoalaWidget() {
    return document.querySelector(
      '.koala-bundles, .koala-bundle, .koala-widget, [class*="koala"], [id*="koala"]'
    );
  }

  function moveKoalaWidget() {
    const koalaWidget = findKoalaWidget();
    const anchor = document.getElementById("koala-bundles-anchor");
    if (!koalaWidget || !anchor) return false;

    // przenieś Koalę pod "Kup teraz" (anchor jest zaraz pod przyciskami)
    anchor.insertAdjacentElement("afterend", koalaWidget);

    return true;
  }

  function init() {
    if (moveKoalaWidget()) return;

    const observer = new MutationObserver(() => {
      if (moveKoalaWidget()) observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 10000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
